import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const loopqualComponent = Loadable(() => import('../containers/Loopqual'));
export default MapTo('vcg/components/soe-home/react/retail/Loopqual')(loopqualComponent);
